import { connect } from 'react-redux';

import chargesActions from '_store/_actions/charges';
import companyPaymentGatewaysActions from '_store/_actions/companyPaymentGateways';

import ChargesList from './ChargesList';

const mapStateToProps = state => ({
  activeCompany: state.company.activeCompany,
  charges: state.companyCharges.charges,
  totalCharges: state.companyCharges.total,
  isLoading: state.companyCharges.loading,
  recipients: state.companyTransactions.recipients,
  paymentMethods: state.companyPaymentGateways.paymentMethods,
});

const mapDispatchToProps = {
  onFetchCharges: chargesActions.fetchCharges,
  onCreateCharge: chargesActions.createCharge,
  onEditCharge: chargesActions.updateCharge,
  onDeleteCharge: chargesActions.deleteCharge,
  onArchiveCharge: chargesActions.archiveCharge,
  onUnarchiveCharge: chargesActions.unarchiveCharge,
  onFetchAvailablePaymentGateways: companyPaymentGatewaysActions.fetchPaymentGateways,
  onFetchAvailablePaymentMethods:
    companyPaymentGatewaysActions.fetchAvailablePaymentMethods,
  onFetchAvailableChargeStatus: companyPaymentGatewaysActions.fetchAvailableChargeStatus,
  onFetchChargesSummary: chargesActions.fetchChargesSummary,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargesList);
